// extracted by mini-css-extract-plugin
export default {"padding":"12","minorPadding":"8.04","hiResDesktopMin":"1300"};